export const loaderFeatureKey = 'loader';

export interface LoaderState {
  actionType: string;
  showLoader: boolean;
}

export const initialLoaderState: LoaderState = {
  actionType: '',
  showLoader: false,
};
